module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<input id="checkbox-' +
((__t = ( id )) == null ? '' : __t) +
'-' +
((__t = ( randomId() )) == null ? '' : __t) +
'" type="checkbox" class="check_mark" name="' +
((__t = ( value )) == null ? '' : __t) +
'" data-id="' +
((__t = ( id )) == null ? '' : __t) +
'" data-type="' +
((__t = ( type )) == null ? '' : __t) +
'">\n<label for="checkbox-' +
((__t = ( id )) == null ? '' : __t) +
'-' +
((__t = ( randomId() )) == null ? '' : __t) +
'" class="filter_item_name" dropdown-value="' +
((__t = ( value )) == null ? '' : __t) +
'" data-id="' +
((__t = ( id )) == null ? '' : __t) +
'" data-type="' +
((__t = ( type )) == null ? '' : __t) +
'"></label>';

}
return __p
}